import GLightbox from 'glightbox'; // @link https://github.com/biati-digital/glightbox

function initCalendarLightbox() {
  const calendarLightbox = GLightbox({
    selector: '.glightbox-calendar',
    width: 500,
    height: 'auto',
    draggable: false,
    zoomable: false,
    keyboardNavigation: false,
    touchFollowAxis: false,
    touchNavigation: false,
  });

  calendarLightbox.on('slide_after_load', (data) => {
    const { slideNode } = data;
    if (window.htmx) {
      // eslint-disable-next-line no-undef
      htmx.process(slideNode);
    }
  });
}

export function initLightbox() {
  GLightbox({ zoomable: false });

  const inlineInfo = document.getElementById('inline-info');
  if (inlineInfo) {
    GLightbox({
      selector: '.inline-info',
      content: inlineInfo,
    }).open();
  }

  if (document.querySelector('.glightbox-calendar')) {
    initCalendarLightbox();
  }

  if (window.htmx) {
    // eslint-disable-next-line no-undef
    htmx.onLoad(() => {
      initCalendarLightbox();
    });
  }
}
